import { useMemo, useState } from "react";
import SectionHead from "./SectionHead";
import { glossaryTerms } from "@/mocks/content";

export default function Glossary() {
  const [kw, setKw] = useState("");
  const [tag, setTag] = useState("全部");

  const tags = ["全部", "基础词", "进阶词", "观感词"];

  const list = useMemo(() => {
    const map: Record<string, string[]> = {
      基础词: ["吃瓜群众", "前排吃瓜"],
      进阶词: ["蹲一个后续", "实锤", "反转"],
      观感词: ["塌房", "洗地", "路人缘"],
    };
    return glossaryTerms.filter((t) => {
      const okTag = tag === "全部" || (map[tag] || []).includes(t.word);
      const q = kw.trim();
      const okKw = !q || t.word.includes(q) || t.text.includes(q);
      return okTag && okKw;
    });
  }, [kw, tag]);

  return (
    <section id="glossary" className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="05 · 黑话词典"
          title="吃瓜圈必备黑话速查"
          desc="想顺利混进评论区，先掌握这一小本“词典”。输入关键词或切换分类，实时筛选你需要的词条。"
        />

        <div className="mt-10 flex flex-col items-stretch gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap gap-2">
            {tags.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTag(t)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  tag === t
                    ? "bg-stone-800 text-white"
                    : "bg-[#fff4e6] text-stone-600 hover:bg-orange-100"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
          <div className="relative w-full md:w-72">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-stone-400" aria-hidden="true" />
            <input
              type="search"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜索黑话…"
              aria-label="搜索黑话"
              className="w-full rounded-full border border-stone-200 bg-[#fffaf2] py-2.5 pl-11 pr-4 text-sm text-stone-700 outline-none transition focus:border-rose-400 focus:ring-2 focus:ring-rose-100"
            />
          </div>
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {list.map((t) => (
              <article
                key={t.word}
                className="group flex flex-col rounded-3xl bg-[#fff8f0] p-5 ring-1 ring-orange-100 transition-all hover:-translate-y-1 hover:bg-white hover:ring-rose-200"
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-bold text-stone-800">{t.word}</h3>
                  <span className="grid h-8 w-8 place-items-center rounded-lg bg-rose-100 text-rose-500 transition-colors group-hover:bg-rose-500 group-hover:text-white">
                    <i className="ri-arrow-right-up-line" aria-hidden="true" />
                  </span>
                </div>
                <p className="mt-1 text-xs text-emerald-600">{t.pinyin}</p>
                <p className="mt-3 text-sm leading-relaxed text-stone-500">{t.text}</p>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-3xl bg-[#fff4e6] p-10 text-center">
            <i className="ri-inbox-line text-4xl text-orange-300" aria-hidden="true" />
            <p className="mt-3 text-stone-500">没找到匹配的黑话，换个关键词试试吧。</p>
          </div>
        )}
      </div>
    </section>
  );
}